import TableCellPropertyCommand from './tablecellpropertycommand';

export default class TableCellBackgroundColorCommand extends TableCellPropertyCommand {
    /**
     * Creates a new `TableCellBackgroundColorCommand` instance.
     *
     * @param editor An editor in which this command will be used.
     * @param defaultValue The default value of the attribute.
     */
    constructor(editor, defaultValue) {
        super(editor, 'tableCellBackgroundColor', defaultValue);
    }
}
